export default __webpack_public_path__ + "static/media/Codex_Vaticanus_end_or_Luke.4720014d.jpg";